import { ButtonPrimary } from "components/Atoms/Button";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
import { ProductionPreviewPanelContent } from "./ProductionPreviewPanelContent";

interface ProductionPreviewPanelProps {
  productionId: number
}

const ProductionPreviewPanel = (props: ProductionPreviewPanelProps) => {
  const { productionId } = props;

  const api = useApi(() => window.CoreApi.Production.GetPreviewPanelData(productionId), ["production", productionId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [productionId]);

  if (api.isInitialLoading) {
    return <>
      <PreviewPanelHeader title={site.currentEnvironment.production.singular} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const isInternal = site.currentEnvironment.type === "internal";
  const data = api.data;

  return <>
    <PreviewPanelHeader title={site.currentEnvironment.production.singular} />

    <ProductionPreviewPanelContent
      production={data.production}
      freeFieldCategories={data.freeFieldCategories}
    />

    {isInternal && <PreviewPanelFooter>
      <ButtonPrimary href={routes.production_Detail(productionId).absolute} label={RESX.Buttons.DetailView} />
    </PreviewPanelFooter>}
  </>;
};

interface ProductionPreviewProps {
  productionId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const ProductionPreview = (props: ProductionPreviewProps) => {
  if (!site.permissions.production.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`production-preview-${props.productionId}`}>
    <ProductionPreviewPanel productionId={props.productionId} />
  </PreviewPanel>;
};
